import React from "react";

import { ConfirmModal } from "@amphore-dev/amphore-lib";
import { t } from "i18next";
import { Trans } from "react-i18next";

export interface IArchiveConfirmModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	kind: "project" | "view";
	name: string;
}

/**
 * Before archiving a project or a view: says what archiving does, since
 * it is not the same for both - a project turns read-only and leaves the
 * plan's count, a view only leaves the sidebar. Unarchiving asks nothing.
 */
export const ArchiveConfirmModal: React.FC<IArchiveConfirmModalProps> = ({
	kind,
	name,
	onConfirm,
	onClose,
	...props
}) => (
	<ConfirmModal
		{...props}
		onClose={onClose}
		onConfirm={() => {
			onConfirm();
			onClose();
		}}
		title={t(`archive.${kind}.title`)}
		confirmText={t("actions.archive")}
		cancelText={t("actions.cancel")}
		portal
	>
		<Trans
			i18nKey={`archive.${kind}.message`}
			values={{ name }}
			components={{ b: <b /> }}
		/>
	</ConfirmModal>
);
